<template>
  <router-view></router-view>
  <NotificationToast />
</template>

<script setup>
import NotificationToast from './components/NotificationToast.vue'
</script>

<style>
</style>
